import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideRequestLocation } from './ride-request-location';
import { RideRequestType } from './ride-request-type';
import { OrganizationInfo } from './organization-info';
import { ServiceLevel } from './service-level';

@inheritSerialization(AbstractModel)
export class TripListItem extends AbstractModel {
  @autoserialize
  rideRequestId: number;

  @autoserialize
  reservationId: number;

  @autoserialize
  journeyId: number;

  @autoserialize
  itineraryId: number;

  @autoserialize
  status: string;

  @autoserializeAs(RideRequestLocation)
  pickupLocation: RideRequestLocation;

  @autoserializeAs(RideRequestLocation)
  dropoffLocation: RideRequestLocation;

  @autoserializeAs(RideRequestType)
  rideRequestType: RideRequestType;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserializeAs(Date)
  scheduledPickupTime: Date;

  @autoserialize
  distanceMeters: number;

  @autoserialize
  durationSeconds: number;

  @autoserializeAs(Date)
  activatedAt: Date;

  @autoserialize
  timeZone: string;

  @autoserialize
  rideBackupEligible: boolean;

  @autoserializeAs(OrganizationInfo)
  organizationInfo: OrganizationInfo;

  @autoserializeAs(ServiceLevel)
  minimumServiceLevel: ServiceLevel;

  @autoserializeAs(ServiceLevel)
  executedServiceLevel: ServiceLevel;

  @autoserialize
  provider: string;

  static OnSerialized(instance: TripListItem, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeLocalDate(instance.pickupDate);
    }

    if (!isNullOrUndefined(instance.scheduledPickupTime)) {
      json.scheduledPickupTime = DateUtil.serializeLocalDate(instance.scheduledPickupTime);
    }

    if (!isNullOrUndefined(instance.activatedAt)) {
      json.activatedAt = instance.activatedAt.getTime();
    }
  }

  static OnDeserialized(instance: TripListItem, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeLocalDate(json['pickupDate'], json['timeZone']);
    }

    if (!isNullOrUndefined(json['scheduledPickupTime'])) {
      const fullDateString = json['pickupDate'] + 'T' + json['scheduledPickupTime'];
      instance.scheduledPickupTime = DateUtil.deserializeLocalDate(fullDateString, json['timeZone']);
    }

    if (!isNullOrUndefined(json['activatedAt'])) {
      instance.activatedAt = new Date(json['activatedAt']);
    }
  }
}
